import { render, staticRenderFns } from "./dialog-alert-passwordexpired.vue?vue&type=template&id=08e2b07b&"
import script from "./dialog-alert-passwordexpired.vue?vue&type=script&lang=js&"
export * from "./dialog-alert-passwordexpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports